import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { a as d } from "../../../../index-CROKJrb5.js";
import { c as p, f as j } from "../../../../create-component-CBAeEoQ6.js";
import { ControlCardTitle as C } from "../ControlCardTitle/index.js";
import { CardMeta as h } from "../../CardMeta/index.js";
const y = p(
  "ControlCardContent",
  j(
    ({
      as: u,
      children: s,
      className: n,
      fullyClickable: a,
      image: t = null,
      input: e,
      label: o = null,
      meta: l = null,
      rating: f = null,
      title: c = null,
      ...i
    }, m) => {
      const x = u || (a ? "label" : "div");
      return /* @__PURE__ */ r.jsx(x, { className: d("cur-grow", n), ref: m, ...i, children: /* @__PURE__ */ r.jsxs("div", { className: "cur-block cur-p-2", children: [
        /* @__PURE__ */ r.jsxs("div", { className: "cur-mb-4 cur-flex cur-w-full cur-items-start cur-justify-between cur-gap-3", children: [
          t,
          /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-flex-1 cur-flex-col cur-flex-wrap cur-gap-2", children: [
            o && /* @__PURE__ */ r.jsx("div", { className: "cur-flex cur-flex-wrap", children: o }),
            c && (typeof c == "string" ? /* @__PURE__ */ r.jsx(C, { children: c }) : c),
            typeof l == "string" ? /* @__PURE__ */ r.jsx(h, { children: l }) : l,
            f
          ] }),
          e && /* @__PURE__ */ r.jsx("div", { className: "cur-flex-none", children: e })
        ] }),
        s ? /* @__PURE__ */ r.jsx("div", { className: "cur-flex cur-w-full cur-flex-col cur-gap-4 [&>div]:cur-mb-0 [&_p]:cur-mb-2 last:[&_p]:cur-mb-0", children: s }) : null
      ] }) });
    }
  )
);
export {
  y as ControlCardContent
};
//# sourceMappingURL=index.js.map
